import { z } from "zod";

export const eventTypeSchema = z.enum([
  "goal",
  "own_goal",
  "penalty_goal",
  "yellow_card",
  "second_yellow",
  "red_card",
  "substitution",
  "var_check",
  // PFL 3/9/10. `penalty_missed` — a penalty missed during play;
  // `shootout_*` — the penalty shootout (NOT counted in the main score, fills
  // the little_pen panel).
  "penalty_missed",
  "shootout_goal",
  "shootout_missed",
]);
export type EventType = z.infer<typeof eventTypeSchema>;

export const matchEventSchema = z.object({
  id: z.string(),
  matchId: z.string(),
  type: eventTypeSchema,
  teamId: z.string(),
  playerId: z.string(),
  assistPlayerId: z.string().nullable().optional(),
  minute: z.number().int().min(0).max(130),
  second: z.number().int().min(0).max(59),
  data: z.record(z.unknown()).optional(),
  createdAt: z.string().datetime(),
});
export type MatchEvent = z.infer<typeof matchEventSchema>;
